import { createRouter, createWebHistory } from "vue-router"

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import(/* webpackChunkName: "page" */ "./views/Search.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/search",
      name: "search",
      component: () => import(/* webpackChunkName: "page" */ "./views/Search.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/schedule",
      name: "schedule",
      component: () => import(/* webpackChunkName: "page" */ "./views/Schedule.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/scheduler",
      name: "scheduler",
      component: () => import(/* webpackChunkName: "page" */ "./views/Scheduler.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/customers",
      name: "customers",
      component: () => import(/* webpackChunkName: "page" */ "./views/Customers.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/suspended",
      name: "suspended",
      component: () => import(/* webpackChunkName: "page" */ "./views/Suspended.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/customer",
      name: "customer",
      component: () => import(/* webpackChunkName: "page" */ "./views/Customer.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/customer/:id",
      name: "edit-customer",
      component: () => import(/* webpackChunkName: "page" */ "./views/Customer.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/materials",
      name: "materials",
      component: () => import(/* webpackChunkName: "page" */ "./views/Materials.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/pests",
      name: "pests",
      component: () => import(/* webpackChunkName: "page" */ "./views/Pests.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/engineers",
      name: "engineers",
      component: () => import(/* webpackChunkName: "page" */ "./views/Engineers.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/staff",
      name: "staff",
      component: () => import(/* webpackChunkName: "page" */ "./views/Staff.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/password",
      name: "password",
      component: () => import(/* webpackChunkName: "page" */ "./views/Password.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/visit-contract/:customer",
      name: "contract-visit",
      component: () => import(/* webpackChunkName: "page" */ "./views/VisitContract.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/visit-contract-edit/:customer/:visit",
      name: "visit-contract-edit",
      component: () => import(/* webpackChunkName: "page" */ "./views/VisitContract.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/job-oneoff/:customer/:job_id",
      name: "oneoff-job",
      component: () => import(/* webpackChunkName: "page" */ "./views/JobOneOff.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/job/:id",
      name: "edit-job",
      component: () => import(/* webpackChunkName: "page" */ "./views/JobOneOff.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/visit-oneoff/:job/:customer",
      name: "oneoff-visit",
      component: () => import(/* webpackChunkName: "page" */ "./views/VisitOneOff.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/visit-oneoff-edit/:customer/:job/:visit",
      name: "visit-oneoff-edit",
      component: () => import(/* webpackChunkName: "page" */ "./views/VisitOneOff.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/engineer-schedule",
      name: "engineer-schedule",
      component: () => import(/* webpackChunkName: "page" */ "./views/Schedule.vue")
    },
    {
      path: "/engineer-holiday-request",
      name: "engineer-holiday-request",
      component: () => import(/* webpackChunkName: "page" */ "./views/EngineerHolidayRequest.vue")
    },
    {
      path: "/holiday-request",
      name: "holiday-request",
      component: () => import(/* webpackChunkName: "page" */ "./views/HolidayRequest.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/engineer-timesheet",
      name: "engineer-timesheet",
      component: () => import(/* webpackChunkName: "page" */ "./views/EngineerTimesheet.vue")
    },
    {
      path: "/timesheet",
      name: "timesheet",
      component: () => import(/* webpackChunkName: "page" */ "./views/Timesheet.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/engineer-visit-oneoff/:customer/:job/:visit",
      name: "engineer-visit-oneoff",
      component: () => import(/* webpackChunkName: "page" */ "./views/EngineerOneOff.vue")
    },
    {
      path: "/engineer-visit-contract/:customer/:visit",
      name: "engineer-visit-contract",
      component: () => import(/* webpackChunkName: "page" */ "./views/EngineerContractVisit.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackChunkName: "page" */ "./views/Login.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/stock-control",
      name: "stock-control",
      component: () => import(/* webpackChunkName: "page" */ "./views/StockControl.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/engineer-stock-control",
      name: "engineer-stock-control",
      component: () => import(/* webpackChunkName: "page" */ "./views/EngineerStockControl.vue"),
    },
    {
      path: "/table-name",
      name: "table-name",
      component: () => import(/* webpackChunkName: "page" */ "./views/TableName.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/pdf",
      name: "pdf",
      component: () => import(/* webpackChunkName: "page" */ "./views/PDF.vue"),
      meta: { isAdmin: true }
    },
    // Vehicle Inspection Routes
    {
      path: "/vehicles",
      name: "vehicles",
      component: () => import(/* webpackChunkName: "page" */ "./views/Vehicles.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/vehicle-inspection",
      name: "vehicle-inspection",
      component: () => import(/* webpackChunkName: "page" */ "./views/VehicleInspectionsCompleted.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/vehicle-inspection-form/:licence_plate?/:employee_name?/:inspected_on?/:week_no?",
      name: "vehicle-inspection-form",
      component: () => import(/* webpackChunkName: "page" */ "./views/VehicleInspectionForm.vue")
    },
    {
      path: "/vehicle-reports",
      name: "vehicle-reports",
      component: () => import(/* webpackChunkName: "page" */ "./views/VehicleReports.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import(/* webpackChunkName: "page" */ "./views/Profile.vue")
    },
    {
      path: "/configurations",
      name: "configurations",
      component: () => import(/* webpackChunkName: "page" */ "./views/Configurations.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
